import React, { FC } from 'react';
import MuiTextField, { TextFieldProps } from '@material-ui/core/TextField';

export const TextField: FC<TextFieldProps> = (props) => <MuiTextField {...props} />;
